import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Space, Popconfirm, Button, Row, Col, Tooltip, Modal } from 'antd';
import * as tableListSelector from 'redux/selectors/tableList';
import * as productClassActions from 'redux/actions/productClass';
import * as productClassService from 'redux/services/productClass';
import * as listActions from 'redux/actions/list';
import { Link } from 'react-router-dom';
import { WrapperTable } from 'components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class List extends Component {
  state = { keyCount: 0 };

  componentWillUnmount() {
    this.props.unload();
  }

  deleteClass = id => {
    (async () => {
      try {
        await productClassService.remove(id);
        this.setState({ keyCount: this.state.keyCount + 1 });
      } catch (err) {
        Modal.error({ title: 'Error', content: 'Product class is still in use by one or more products.' });
      }
    })();
  };

  columns = [
    { title: 'Name', dataIndex: 'name', sorter: true },
    { title: 'Description', dataIndex: 'description' },
    { title: 'Default', dataIndex: 'isDefault', render: v => (v ? 'Yes' : 'No') },
    {
      title: 'Action',
      dataIndex: 'id',
      render: id => (
        <Space>
          <Link to={`/catalog/productClass/view/${id}/`}>view</Link>
          <Link to={`/catalog/productClass/edit/${id}/`}>edit</Link>
          <Popconfirm
            title="Delete this product class?"
            okText="Yes"
            cancelText="No"
            onConfirm={() => this.deleteClass(id)}
          >
            <Button type="link">delete</Button>
          </Popconfirm>
        </Space>
      )
    }
  ];

  render() {
    const tableAction = (
      <Link to="/catalog/productClass/create/">
        <Tooltip title="Create Product Class">
          <FontAwesomeIcon icon="plus-square" />
        </Tooltip>
      </Link>
    );
    return (
      <Row>
        <Col span={24}>
          <WrapperTable
            title="Product Class List"
            key={this.state.keyCount}
            filters={[{ field: 'name', type: 'TEXT' }]}
            columns={this.columns}
            tableAction={tableAction}
            data={this.props.listData}
            api={this.props.searchClasses}
          />
        </Col>
      </Row>
    );
  }
}

export default connect(
  state => ({ listData: tableListSelector.listData(state) }),
  { searchClasses: productClassActions.search, unload: listActions.listUnload }
)(List);
